<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">Acessos da Devedora</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn type="button" color="primary" elevation="0" to="/acessos-devedora/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="search">
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="Nome" v-model="filter.name" hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="E-mail" v-model="filter.email" hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete dense :items="clients" label="Caso" v-model="filter.client_id" item-value="id"
                                        item-text="name" outlined hide-details clearable no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Acessos</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="items" :server-items-length="count" :disable-sort="true"
                            :loading="loading" no-data-text="Nenhum acesso cadastrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="options" :footer-props="footerOptions">
                            <template v-slot:[`item.name`]="{ item }">
                                <span class="text-capitalize">{{ item.name }}</span>
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate('DD/MM/YYYY') }}
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon @click="viewItem(item)" size="large" class="me-2">mdi-pencil-outline</v-icon>
                                <v-icon @click="remove(item)" size="large">mdi-delete-outline</v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "ClientUserList",

    data: () => ({
        loading: false,
        items: [],
        count: 0,
        clients: [],
        filter: { name: "", email: "", client_id: null },
        options: { page: 1, itemsPerPage: 10 },
        footerOptions: {
            itemsPerPageText: 'Itens por página:',
            itemsPerPageOptions: [10, 20, 30, 40, 50],
            pageText: '{0}-{1} de {2}',
        },
        headers: [
            { text: "Nome", value: "name" },
            { text: "E-mail", value: "email" },
            { text: "Caso", value: "client.name" },
            { text: "Criado em", value: "created_at" },
            { text: "Ações", value: "actions", sortable: false },
        ],
    }),

    computed: {
        breadcrumbItems() {
            return [
                { text: 'Início', to: '/home', exact: true },
                { text: 'Acessos da Devedora', disabled: true },
            ];
        },
    },

    watch: {
        options: {
            handler() { this.load(); },
            deep: true,
        },
    },

    created() {
        this.loadClients();
    },

    methods: {
        async loadClients() {
            try {
                const result = await axios.get('/api/clients', { params: { page: 1, limit: 1000 } });
                this.clients = result.data.content.data;
            } catch (error) {
                this.clients = [];
            }
        },

        search() {
            if (this.options.page !== 1) this.options = { ...this.options, page: 1 };
            else this.load();
        },

        async load() {
            this.loading = true;

            try {
                const search = Object.fromEntries(Object.entries(this.filter).filter(([, value]) => value));
                const result = await axios.get('/api/admin/client-users', {
                    params: { page: this.options.page, limit: this.options.itemsPerPage, search: JSON.stringify(search) },
                });

                this.items = result.data.content.data;
                this.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        viewItem(item) {
            this.$router.push(`/acessos-devedora/${item.id}`);
        },

        async remove(item) {
            const confirmed = await this.$dialog.confirm({
                title: 'Remover acesso',
                text: `Remover o acesso de ${item.name} ao Painel da Devedora? A pessoa perde o acesso na hora.`,
                actions: { false: 'Cancelar', true: 'Remover' },
            });
            if (!confirmed) return;

            try {
                await axios.delete(`/api/admin/client-users/${item.id}`);
                this.$dialog.notify.info('Acesso removido.', { position: 'top-right', timeout: 2000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            }
        },
    },
};
</script>
